// extracted by mini-css-extract-plugin
export default {"artbook":"src-components-Artbook-module__artbook--ZY2Ps","hidden":"src-components-Artbook-module__hidden--lOKne"};